import type { HWPXDocument, WriteOptions } from '../../types.js';
import { createZip, encodeUtf8, type ZipEntry } from './zip.js';
import { generateVersionXml } from './xml/version.js';
import { generateContainerXml } from './xml/container.js';
import { generateManifestXml, buildManifestEntries } from './xml/manifest.js';
import { generateSettingsXml } from './xml/settings.js';
import { generateContentHpfXml } from './xml/content-hpf.js';
import { generateHeaderXml } from './xml/header.js';
import { generateSectionXml } from './xml/section.js';
import { NS } from './ns.js';

export function writeHwpx(doc: HWPXDocument, _opts?: WriteOptions): Uint8Array {
  const entries: ZipEntry[] = [];

  // mimetype — 반드시 첫 번째, 비압축
  entries.push({
    path: 'mimetype',
    data: encodeUtf8(NS.mimeHwpx),
    store: true,
  });

  // META-INF/container.xml
  entries.push({
    path: 'META-INF/container.xml',
    data: encodeUtf8(generateContainerXml()),
  });

  // META-INF/manifest.xml
  const manifestEntries = buildManifestEntries(
    doc.sections.length,
    doc.binData.map((b) => ({ name: b.name, format: b.format })),
  );
  entries.push({
    path: 'META-INF/manifest.xml',
    data: encodeUtf8(generateManifestXml(manifestEntries)),
  });

  // version.xml
  entries.push({
    path: 'version.xml',
    data: encodeUtf8(generateVersionXml(doc.meta)),
  });

  // settings.xml
  entries.push({
    path: 'settings.xml',
    data: encodeUtf8(generateSettingsXml()),
  });

  // Contents/content.hpf
  entries.push({
    path: 'Contents/content.hpf',
    data: encodeUtf8(generateContentHpfXml(doc)),
  });

  // Contents/header.xml
  entries.push({
    path: 'Contents/header.xml',
    data: encodeUtf8(generateHeaderXml(doc.head)),
  });

  // Contents/section*.xml
  for (let i = 0; i < doc.sections.length; i++) {
    entries.push({
      path: `Contents/section${i}.xml`,
      data: encodeUtf8(generateSectionXml(doc.sections[i], i)),
    });
  }

  // BinData/*
  for (const bin of doc.binData) {
    entries.push({
      path: `BinData/${bin.name}`,
      data: bin.data,
    });
  }

  return createZip(entries);
}
